module.exports = __webpack_public_path__ + "static/zmigord_entire_page-978542e6ce0996161771b8742455d19c.jpg";